import { render, staticRenderFns } from "./AlertLoginForbidden.vue?vue&type=template&id=36fff982&scoped=true&"
import script from "./AlertLoginForbidden.vue?vue&type=script&lang=js&"
export * from "./AlertLoginForbidden.vue?vue&type=script&lang=js&"
import style0 from "./AlertLoginForbidden.vue?vue&type=style&index=0&id=36fff982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fff982",
  null
  
)

export default component.exports